import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/termos-de-uso")({
  head: () => ({
    meta: [
      { title: "Termos de Uso — Dr. Ulisses Contente" },
      {
        name: "description",
        content:
          "Termos de Uso do site do Dr. Ulisses Contente.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: TermosDeUso,
});

function TermosDeUso() {
  return (
    <main className="min-h-screen bg-[#F7F6F3] text-[#1C1C1E]">
      <div className="mx-auto max-w-[720px] px-6 py-14 md:py-20">
        <Link to="/" className="text-[14px] text-[#17724F] underline">
          ← Voltar
        </Link>

        <h1 className="mt-6 font-bold text-[30px] md:text-[36px] leading-[1.2]">
          Termos de Uso
        </h1>
        <p className="mt-3 text-[14px] text-[#6B6B70]">
          Última atualização: 2026.
        </p>

        <div className="mt-8 flex flex-col gap-6 text-[16px] text-[#3A3A3E] leading-[1.7]">
          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">1. Aceitação</h2>
            <p className="mt-2">
              Ao acessar este site, você concorda com estes Termos de Uso. Se não concordar com qualquer disposição, por favor, não utilize o site.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">2. Finalidade do site</h2>
            <p className="mt-2">
              Este site tem caráter exclusivamente informativo, apresentando os serviços de atendimento médico particular por telemedicina prestados pelo Dr. Ulisses Contente, médico inscrito no CRM/SP 245805. As informações aqui contidas não substituem consulta, diagnóstico ou tratamento médico individual.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">3. Formulário de contato</h2>
            <p className="mt-2">
              O envio de dados pelo formulário não caracteriza início de tratamento nem cria vínculo médico-paciente. O atendimento clínico só se inicia após consulta agendada e confirmada.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">4. Propriedade intelectual</h2>
            <p className="mt-2">
              Todo o conteúdo publicado neste site — textos, imagens, marcas e layout — é de titularidade do Dr. Ulisses Contente e/ou [Razão social] e não pode ser reproduzido, distribuído ou utilizado sem autorização prévia por escrito.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">5. Limitação de responsabilidade</h2>
            <p className="mt-2">
              Não garantimos que o site estará sempre disponível, livre de erros ou de interrupções. Nenhum resultado clínico é garantido, uma vez que a resposta ao tratamento varia de pessoa para pessoa.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">6. Legislação aplicável</h2>
            <p className="mt-2">
              Estes Termos são regidos pela legislação brasileira. Fica eleito o foro do domicílio do prestador para dirimir quaisquer controvérsias, salvo disposição legal em contrário.
            </p>
          </section>

          <section>
            <h2 className="text-[20px] font-semibold text-[#1C1C1E]">7. Contato</h2>
            <p className="mt-2">
              Dúvidas sobre estes Termos podem ser enviadas para [e-mail].
            </p>
          </section>
        </div>
      </div>
    </main>
  );
}
